import { render, staticRenderFns } from "./settings-card.vue?vue&type=template&id=1d6a1d8e&scoped=true&"
import script from "./settings-card.vue?vue&type=script&lang=js&"
export * from "./settings-card.vue?vue&type=script&lang=js&"
import style0 from "./settings-card.vue?vue&type=style&index=0&id=1d6a1d8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a1d8e",
  null
  
)

export default component.exports